import { useTranslations } from '@lang';
import { getGuestGenderByTitle, isGuestAlreadyInArray } from '@utils/helpers';
import { FC } from 'react';
import { Guest } from 'shared-types/Basket';
import { AddExistingGuestsWrapper, CardTitle, PillWrapper } from './AddExistingGuests.styles';
import { GuestLabel } from './GuestLabel';
import { GuestPill } from './GuestPill';
import { displayedGuests, handleGuestPillClick } from './utils';

export type AddExistingGuestsProps = {
  selectedGuests: Guest[];
  existingGuests: Guest[];
  isGenderSpecific?: string | boolean;
  minimumGuests?: number | null;
  maximumGuests?: number | null;
  guest: Guest;
  withTopMargin?: boolean;
  fields?: any;
};

export const AddExistingGuests: FC<AddExistingGuestsProps> = ({
  selectedGuests,
  existingGuests = [],
  guest,
  isGenderSpecific = false,
  minimumGuests,
  maximumGuests,
  fields,
  withTopMargin = false,
}) => {
  const { t } = useTranslations();

  let defaultGender = '';
  if (isGenderSpecific === 'M') {
    defaultGender = 'male';
  } else if (isGenderSpecific === 'F') {
    defaultGender = 'female';
  }

  const availableGuests = existingGuests.map((aGuest) => ({
    ...aGuest,
    gender: aGuest.gender || getGuestGenderByTitle(guest?.title),
  }));

  const loggedGuestData =
    guest && guest.firstName && guest.lastName
      ? {
          ...guest,
          firstName: guest.firstName,
          lastName: guest.lastName,
          title: guest.title,
          gender: guest.gender || getGuestGenderByTitle(guest?.title),
          ...(guest.externalSpaId ? { externalSpaId: guest.externalSpaId } : { isLead: true }),
          loggedInUser: guest.id ? { id: guest.id } : undefined,
        }
      : null;

  if (loggedGuestData && !isGuestAlreadyInArray(availableGuests, loggedGuestData)) {
    availableGuests.push(loggedGuestData);
  }

  return displayedGuests(availableGuests, isGenderSpecific) &&
    displayedGuests(availableGuests, isGenderSpecific).length > 0 ? (
    <AddExistingGuestsWrapper withTopMargin={withTopMargin}>
      <CardTitle>{t('common.addExistingGuests')}</CardTitle>
      <div>
        <PillWrapper>
          {displayedGuests(availableGuests, isGenderSpecific).map((singleGuest, index) => {
            return (
              <GuestPill
                key={index}
                isActive={isGuestAlreadyInArray(selectedGuests, singleGuest)}
                onClick={() =>
                  handleGuestPillClick(
                    singleGuest,
                    fields,
                    selectedGuests,
                    minimumGuests,
                    maximumGuests,
                    defaultGender
                  )
                }
                label={<GuestLabel guest={singleGuest} />}
              />
            );
          })}
        </PillWrapper>
      </div>
    </AddExistingGuestsWrapper>
  ) : null;
};
